import { render, staticRenderFns } from "./TraceabilityMainView.vue?vue&type=template&id=11462344"
import script from "./TraceabilityMainView.vue?vue&type=script&lang=js"
export * from "./TraceabilityMainView.vue?vue&type=script&lang=js"
import style0 from "./TraceabilityMainView.vue?vue&type=style&index=0&id=11462344&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports